import { HttpAuth } from '../../config/Http'
import { changeLoading } from './loading.action'
import { changeNotify } from './notify.action'
import { changeAlert } from './alert.action'

export const actionTypes = {
    INDEX: 'APP_INDEX',
    SUCCESS: 'MERCADOPAGO_SUCCESS',
    ERROR: 'MERCADOPAGO_ERROR'
}

export const error = (payload) => ({
    type: actionTypes.ERROR,
    payload
})

export const success = (payload) => ({
    type: actionTypes.SUCCESS,
    payload
})

export const credential = (data) => dispatch =>  {
    dispatch(changeLoading({ open: true }))

    return HttpAuth.post('/mercadopago/credential', data)
            .then(res => {
                dispatch(changeLoading({ open: false }))
                if(typeof res !== 'undefined') {
                    window.location.href = '/mercadopago?success';
					
                    dispatch(changeNotify({
                        open: true,
                        msg: res.data.msg,
                        class: 'success'
                    }))
                }
            })
            .catch(erro => {
                if(erro.response) {
                    if(erro.response.data.msg) {
                        dispatch(changeAlert({
                            open: true,
                            msg: erro.response.data.msg,
                            class: erro.response.data.class
                        }))
                    }
                }
                dispatch(changeLoading({ open: false }))
            })
}